/* 🤖 this file was generated by svg-to-ts */
export const matIconViewComfy: {
  name: 'view-comfy';
  data: string;
} = {
  name: 'view-comfy',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2 4v16h20V4H2zm2 2h16v5H4V6zm0 12v-5h4v5H4zm6 0v-5h10v5H10z"/></svg>`
};
